export const options = state => state.studiesReducer.module.instance.options
